import { render, staticRenderFns } from "./FrequencySelect.vue?vue&type=template&id=616b2d10&"
import script from "./FrequencySelect.vue?vue&type=script&lang=js&"
export * from "./FrequencySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports